/**
 * Main St. Gifts — Quote Page Pre-fill v2
 * =========================================
 * Targets Hulk Form Builder's Order Details field (form_input_4)
 * and pre-fills it with order details from URL parameters.
 *
 * INSTALL:
 * Layout/theme.liquid before </body>:
 *   {% if page.handle == 'request-a-quote' %}
 *     <script src="{{ 'mainst-quote-prefill.js' | asset_url }}" defer></script>
 *   {% endif %}
 */

(function () {
  'use strict';

  function getParam(key) {
    return new URLSearchParams(window.location.search).get(key) || '';
  }

  function waitForField(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 60) {
      console.log('mainst-prefill: could not find form_input_4 after 60 attempts');
      return;
    }
    const field = document.getElementById('form_input_4');
    if (field) {
      // Wait an extra 300ms after finding it to let Hulk finish initializing
      setTimeout(function() { callback(field); }, 300);
    } else {
      setTimeout(function() { waitForField(callback, attempts + 1); }, 200);
    }
  }

  function buildMessage() {
    const product      = getParam('product');
    const qty          = getParam('quantity');
    const qtyRange     = getParam('qty_range');
    const colors       = getParam('colors');
    const decoration   = getParam('decoration');
    let garmentColor   = getParam('garment_color');
    if (garmentColor.startsWith('QTY')) garmentColor = '';
    const locations    = getParam('locations');
    const colorMatch   = getParam('color_match');
    const pricing      = getParam('pricing');
    const reason       = getParam('reason');
    const isEmbroidery = decoration.toLowerCase() === 'embroidery';

    let msg = '=== ORDER DETAILS ===\n\n';

    if (product)      msg += 'Product:       ' + product + '\n';
    if (qty)          msg += 'Quantity:      ' + qty + ' items';
    if (qtyRange)     msg += ' (' + qtyRange + ')';
    if (qty || qtyRange) msg += '\n';
    if (garmentColor) msg += 'Garment color: ' + garmentColor + '\n';
    if (decoration)   msg += 'Decoration:    ' + decoration + '\n';

    if (isEmbroidery) {
      msg += '\nNote: Embroidery pricing is based on stitch count.\n';
      msg += 'Please describe your design below so we can provide an accurate quote.\n';
    } else {
      if (colors && colors !== '1 color') msg += 'Colors:        ' + colors + '\n';
      if (locations)    msg += 'Imprint location(s): ' + locations + '\n';
      if (colorMatch === 'Yes') msg += 'Color match:   Yes (+$22/order)\n';

      if (pricing) {
        var cleanPricing = pricing
          .replace(/LIVE PRICING[^|]*/i, '')
          .split(' | ')
          .map(function(s) { return s.trim(); })
          .filter(function(s) { return s.length > 0; })
          .join('\n');

        if (cleanPricing) {
          msg += '\n=== PRICING BREAKDOWN ===\n' + cleanPricing + '\n';
        }
      }
    }

    if (reason && reason !== 'undefined') {
      msg += '\nReason for quote: ' + reason + '\n';
    }

    msg += '\n=== ADDITIONAL DETAILS ===\n';
    msg += 'Please add any notes, artwork details, or questions here:\n';

    return msg.trim();
  }

  waitForField(function(field) {
    if (!field.value) {
      field.value = buildMessage();
      field.style.minHeight = '320px';
      field.style.resize = 'vertical';
      // Trigger React/Vue change events Hulk may be listening for
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Scroll the field into view
    setTimeout(function() {
      field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  });

})();